import { createDirtyChecker, compareByPaths } from "../../gvc/testNewForm/createDirtyChecker";
import { inputToLocation } from "../utils";

export function getDirtyChecker(id: string) {
  return createDirtyChecker(id, inputToLocation, compareByPaths({
    description: { path: "description" },
    tags: { path: "tags" },
  }));
}
